var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.structuralElement
    ? _c("sidebar-widget", {
        attrs: {
          title: _vm.$gettext("Aktionen")
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "ul",
                    {
                      staticClass: "widget-list widget-links cw-action-widget"
                    },
                    [
                      _c(
                        "li",
                        {
                          staticClass: "cw-action-widget-show-toc"
                        },
                        [
                          _c(
                            "button",
                            {
                              on: {
                                click: _vm.toggleTOC
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.tocText) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "cw-action-widget-show-consume-mode"
                        },
                        [
                          _c(
                            "button",
                            {
                              on: {
                                click: _vm.showConsumeMode
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Vollbild einschalten")) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.canEdit && !_vm.blockedByAnotherUser
                        ? _c(
                            "li",
                            {
                              staticClass: "cw-action-widget-edit"
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: _vm.editElement
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$gettext("Seiteneinstellungen")
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canEdit &&
                      _vm.blockedByAnotherUser &&
                      _vm.userIsTeacher
                        ? _c(
                            "li",
                            {
                              staticClass: "cw-action-widget-remove-lock"
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: _vm.removeElementLock
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$gettext("Sperre aufheben")) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canEdit && !_vm.blockedByAnotherUser
                        ? _c(
                            "li",
                            {
                              staticClass: "cw-action-widget-sort"
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: _vm.sortContainers
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$gettext("Abschnitte sortieren")
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canEdit
                        ? _c(
                            "li",
                            {
                              staticClass: "cw-action-widget-add"
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: _vm.addElement
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$gettext("Seite hinzufügen")) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "cw-action-widget-info"
                        },
                        [
                          _c(
                            "button",
                            {
                              on: {
                                click: _vm.showElementInfo
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$gettext("Informationen anzeigen")
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "cw-action-widget-star"
                        },
                        [
                          _c(
                            "button",
                            {
                              on: {
                                click: _vm.createBookmark
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Lesezeichen setzen")) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.context.type === "users"
                        ? _c(
                            "li",
                            {
                              staticClass: "cw-action-widget-link"
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: _vm.linkElement
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Öffentlichen Link erzeugen"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isOwner
                        ? _c(
                            "li",
                            {
                              staticClass: "cw-action-widget-oer"
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: _vm.suggestOER
                                  }
                                },
                                [
                                  _c("translate", [
                                    _vm._v(
                                      "Material für %{oerTitle} vorschlagen"
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isRoot && _vm.canEdit && !_vm.blockedByAnotherUser
                        ? _c(
                            "li",
                            {
                              staticClass: "cw-action-widget-trash"
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: _vm.deleteElement
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$gettext("Seite löschen")) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          1528124772
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }